import { render, staticRenderFns } from "./Q4sPromises.vue?vue&type=template&id=cc431462&scoped=true"
import script from "./Q4sPromises.vue?vue&type=script&lang=ts"
export * from "./Q4sPromises.vue?vue&type=script&lang=ts"
import style0 from "./Q4sPromises.vue?vue&type=style&index=0&id=cc431462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc431462",
  null
  
)

export default component.exports